import React, { useState } from "react";
import { BlockPicker } from "react-color";
import { PageConfiguration } from "./index";
import Color from "color";
import { lowerCase } from "lodash";

const updateArrows = require("./styles/update-arrows.svg");
const closeIcon = require("./styles/remove.svg");

const CustomizeColors = ({
  showPageColors,
  pageConfiguration,
  handleColorChange,
  initialPageConfiguration,
  hidePageColors
}: {
  showPageColors: boolean;
  pageConfiguration: PageConfiguration;
  handleColorChange: Function;
  initialPageConfiguration: PageConfiguration;
  hidePageColors: () => void;
}) => {
  const [showPrimaryColorPicker, togglePrimaryColorPicker] = useState(false);
  const [showSecondaryColorPicker, toggleSecondaryColorPicker] =
    useState(false);
  const [showAccentColorPicker, toggleAccentColorPicker] = useState(false);
  const [showPrimaryColorError, setPrimaryShowColorError] = useState(false);
  const [showSecondaryColorError, setSecondaryShowColorError] = useState(false);

  const isLightError = (color: string) => {
    if (lowerCase(color) == lowerCase("#C1EBED")) return false;
    const isColorLight =
      color === "#ffffff" ? true : Color(color).darken(0.5).isLight();
    return isColorLight;
  };

  return (
    <div
      className={
        "org-color-section " +
        (showPageColors ? "org-color-section-active" : "")
      }
    >
      <img
        src={closeIcon}
        className="org-color-close-mob visible-sm visible-xs visible-md"
        onClick={hidePageColors}
      />
      <div className="org-color-divs">
        <ColorPicker
          title="PRIMARY COLOR"
          description="For the latest banner, dates & icons"
          color={pageConfiguration.primaryColor}
          initialColor={initialPageConfiguration.primaryColor}
          handleColorChange={(colorType: string, color: string) => {
            handleColorChange(colorType, color);
            setPrimaryShowColorError(isLightError(color));
          }}
          showColorPicker={showPrimaryColorPicker}
          toggleColorPicker={togglePrimaryColorPicker}
          colorType="primaryColor"
          showPrimaryColorError={showPrimaryColorError}
        />{" "}
        <ColorPicker
          title="SECONDARY COLOR"
          description="For the upcoming banner & labels"
          color={pageConfiguration.secondaryColor}
          initialColor={initialPageConfiguration.secondaryColor}
          handleColorChange={(colorType: string, color: string) => {
            handleColorChange(colorType, color);
            setSecondaryShowColorError(isLightError(color));
          }}
          showColorPicker={showSecondaryColorPicker}
          toggleColorPicker={toggleSecondaryColorPicker}
          colorType="secondaryColor"
          showSecondaryColorError={showSecondaryColorError}
        />{" "}
        <ColorPicker
          title="ACCENT"
          description="For all the rest"
          color={pageConfiguration.accentColor}
          initialColor={initialPageConfiguration.accentColor}
          handleColorChange={handleColorChange}
          showColorPicker={showAccentColorPicker}
          toggleColorPicker={toggleAccentColorPicker}
          colorType="accentColor"
        />
      </div>
    </div>
  );
};

const ColorPicker = ({
  title,
  description,
  color,
  initialColor,
  toggleColorPicker,
  handleColorChange,
  showColorPicker,
  colorType,
  showPrimaryColorError,
  showSecondaryColorError
}: {
  title: string;
  description: string;
  color: string;
  initialColor: string;
  toggleColorPicker: Function;
  handleColorChange: Function;
  showColorPicker: boolean;
  colorType: string;
  showPrimaryColorError?: boolean;
  showSecondaryColorError?: boolean;
}) => {
  const colorSet = [
    "#FF6900",
    "#EB144C",
    "#00D084",
    "#0693E3",
    "#9900EF",
    "#FCB900",
    "#F78DA7",
    "#7BDCB5",
    "#8ED1FC",
    "#ABB8C3"
  ];

  const [colorValid, toggleColorValid] = useState(true);
  const [colorValue, setColorValue] = useState(color);

  const handleColorValue = (colour: string) => {
    setColorValue(colour);
    let isValid = /^#[0-9A-F]{6}$/i.test(colour);
    if (isValid) handleColorChange(colorType, colour);
    toggleColorValid(isValid);
  };

  return (
    <div className="org-color-div1">
      <p className="org-color-p1">{title}</p>
      <p className="org-color-p2">{description}</p>
      <div className="org-color-input-div">
        <div onClick={_ => toggleColorPicker(!showColorPicker)}>
          <input
            className={
              colorValid ? "org-color-input" : "org-color-input failed-input"
            }
            value={colorValue}
            type="text"
            onChange={(e: any) => handleColorValue(e.target.value.trim())}
          />{" "}
          <div
            className="org-color-preview"
            style={{
              background: color
            }}
          ></div>
        </div>
        <img
          src={updateArrows}
          data-toggle="tooltip"
          title="Reset color"
          aria-hidden="true"
          onClick={_ => handleColorValue(initialColor)}
          className="org-color-update-icon"
        />
      </div>
      {((showPrimaryColorError && colorType === "primaryColor") ||
        (showSecondaryColorError && colorType === "secondaryColor")) && (
        <div className="org-color-error">
          {" "}
          Light color will break the gallery
        </div>
      )}
      {showColorPicker && (
        <div className="color-picker-pop-over">
          <div
            className="color-picker-cover"
            onClick={_ => toggleColorPicker(!showColorPicker)}
          ></div>
          <BlockPicker
            colors={colorSet}
            color={color}
            onChangeComplete={(color: any) => handleColorValue(color.hex)}
          />
        </div>
      )}
    </div>
  );
};
export default CustomizeColors;
